<nav>
  <div [ngClass]="{'openSideNav': isSideNavOpen, 'closeSideNav': !isSideNavOpen}" class="list-wrapper margin-b">
    <div class="list border-r">
      <h5>Manage My Account</h5>
      <div class="items">
        <li class="anchor" (click)="hideSideNav()" routerLink="/dashboard"
          [routerLinkActive]="'activeFeature'">
          <i class="fas fa-tachometer-alt"></i>
          <span>Dashboard</span>
        </li>
      </div>
      <div class="items">
        <li class="anchor" (click)="hideSideNav()" routerLink="/photo-gallery"
          [routerLinkActive]="'activeFeature'">
          <i class="fas fa-images"></i>
          <span>Photo Gallery</span>
        </li>
      </div>
      <div class="items">
        <li class="anchor" (click)="hideSideNav()" routerLink="/campus-greetings"
          [routerLinkActive]="'activeFeature'">
          <i class="fas fa-map-marker-alt"></i>
          <span>Location Greeting</span>
        </li>
      </div>
      <div class="items">
        <li class="anchor" (click)="hideSideNav()" routerLink="/perpetual-add"
          [routerLinkActive]="'activeFeature'">
          <i class="fas fa-tag"></i>
          <span>My Member Discount</span>
        </li>
      </div>
        <div class="items">
        <li class="anchor" (click)="hideSideNav()" routerLink="/analytics"
          [routerLinkActive]="'activeFeature'">
         <i class="fas fa-chart-line"></i>
          <span>Analytics</span>
        </li>
      </div>
      <div class="items">
        <li class="anchor" (click)="hideSideNav()" routerLink="/mysubscration"
          [queryParams]="{ isSub: 'true'}" [routerLinkActive]="'activeFeature'">
          <i class="fas fa-credit-card"></i>
          <span>My Subscription</span>
        </li>
      </div>
      <div class="items">
        <li class="anchor" (click)="hideSideNav()" routerLink="/settings"
          [routerLinkActive]="'activeFeature'">
          <i class="fas fa-cog"></i>
          <span>Account Settings</span>
        </li>
      </div>

      <h5 class="mt-3 mb-0">Post Office</h5>
      <div class="items">
        <li class="anchor" (click)="hideSideNav()" routerLink="/cross-chat"
          [routerLinkActive]="'activeFeature'">
          <i class="fas fa-comments"></i>
          <span>Cross Chat</span>
        </li>
      </div>
      <div class="items">
        <li class="anchor" (click)="hideSideNav()" routerLink="/ministry-postcard"
          [routerLinkActive]="'activeFeature'">
          <i class="fas fa-envelope"></i>
          <span>Ministry Messages</span>
        </li>
      </div>
      <div class="items">
        <li class="anchor" (click)="sendEmail()">
          <i class="fas fa-user-plus"></i>
          <span>Invite Friends/Customers</span>
        </li>
      </div>

      <h5 class="mt-3 mb-0">My Network</h5>
      <div class="items">
        <li class="anchor" (click)="hideSideNav()" routerLink="/my-network/followers" [routerLinkActive]="'activeFeature'">
          <i class="fas fa-users"></i>
          <span>Followers</span>
        </li>
      </div>
      <div class="items">
        <li class="anchor" (click)="hideSideNav()" routerLink="/my-network/affiliation" [routerLinkActive]="'activeFeature'">
          <i class="fas fa-eye"></i>
          <span>Visitors</span>
        </li>
      </div>
      <h5 class="mt-3 mb-0">Business Tools</h5>
      <!-- <div class="items"> <a routerLink="/alerts" routerLinkActive="active-list-second"
            [routerLinkActiveOptions]="{exact: true}">
            Alerts </a></div> -->
      <!-- <div class="items">
        <li
          class="anchor ad"
          (click)="isCollapsed = !isCollapsed"
          routerLink="/perpetual-add"
          [routerLinkActive]="'activeFeature'"
        >
          Create Ads
        </li>
      </div> -->
      <div class="items">
        <li class="anchor" (click)="hideSideNav()" routerLink="/banner-ads"
          [routerLinkActive]="'activeFeature'">
          <i class="fas fa-flag"></i>
          <span>My Business Banner</span>
        </li>
      </div>
      <div class="items">
        <li class="anchor" (click)="hideSideNav()" routerLink="/advertisements"
          [routerLinkActive]="'activeFeature'">
          <i class="fas fa-bullhorn"></i>
          <span>Create Ads</span>
        </li>
      </div>
      <div class="items">
        <li class="anchor" (click)="hideSideNav()" routerLink="/leads"
          [routerLinkActive]="'activeFeature'">
          <i class="fas fa-user-group"></i>
          <span>Leads</span>
        </li>
      </div>
      <div class="items">
        <li class="anchor" (click)="hideSideNav()" routerLink="/my-postcard"
          [routerLinkActive]="'activeFeature'">
          <i class="fas fa-id-card"></i>
          <span>Create Postcards</span>
        </li>
      </div>
      <div class="items">
        <li class="anchor" (click)="hideSideNav()" routerLink="/my-events"
          [routerLinkActive]="'activeFeature'">
          <i class="fas fa-calendar-alt"></i>
          <span>Create Events</span>
        </li>
      </div>
      <div class="items">
        <li class="anchor" (click)="hideSideNav()" routerLink="/create-job"
          [routerLinkActive]="'activeFeature'">
          <i class="fas fa-briefcase"></i>
          <span>Create Job</span>
        </li>
      </div>
      <div class="items">
        <li class="anchor" (click)="hideSideNav()" routerLink="/my-jobs"
          [routerLinkActive]="'activeFeature'">
          <i class="fas fa-list-alt"></i>
          <span>My Jobs</span>
        </li>
      </div>
      <div class="items">
        <li class="anchor" (click)="hideSideNav()" routerLink="/housing-hub"
          [routerLinkActive]="'activeFeature'">
          <i class="fas fa-home"></i>
          <span>Housing Hub</span>
        </li>
      </div>
      <div class="items">
        <li class="anchor" [routerLinkActive]="'activeFeature'">
          <i class="fas fa-coffee"></i>
          <span>Ravel Café</span>
        </li>
      </div>
      <h5 class="mt-3 mb-0">Entrepreneur Center</h5>
      <div class="items">
        <li class="anchor" (click)="hideSideNav()" [routerLinkActive]="'activeFeature'"
          routerLink="/enterpreneur-resource">
          <i class="fas fa-briefcase"></i>
          <span>Additional Business Tools</span>
        </li>
      </div>
      <h5 class="mt-3 mb-0">Support</h5>
      <div class="items">
        <li class="anchor" (click)="support()">
          <i class="fas fa-headset"></i>
          <span>Contact Support</span>
        </li>
      </div>
      <div class="items mt-3">
        <li class="anchor" (click)="goToUrl()">
          <i class="fas fa-globe"></i>
          <span>Ravel Faith Home</span>
        </li>
      </div>
      <!-- <div class="items">
        <li class="anchor" (click)="logout()">
          Logout
        </li>
      </div> -->
    </div>
  </div>
</nav>

<!-- Profile Inactive Modal Template -->
<ng-template #profileInactiveModal let-modal>
  <div class="inactive-modal">
    <button type="button" class="close-btn" aria-label="Close" (click)="modal.dismiss('cross')">
      <span aria-hidden="true">&times;</span>
    </button>

    <h3 class="title">Your profile is inactive</h3>
    <p class="subtitle">Activate your account to appear in search, chat with others, and access all features.</p>
    <div class="actions">
      <button type="button" class="btn-activate" (click)="activateProfile(modal)">Activate Now</button>
    </div>
  </div>
</ng-template>

